import { useState, useEffect } from 'react';
import {
  Button, Grid2 as Grid, Typography, RadioGroup, Radio,
  FormControl, FormControlLabel, IconButton
} from '@mui/material';
import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';
import PropTypes from 'prop-types';
import { sendCode, sendCodeEmail } from '../../actions/users';

import Alert from '../../components/layout/Alerta';

import { useDispatch } from 'react-redux';

const FormSignUpStep2 = ({
  setData,
  navigate, setPasos, data, state
}) => {
  const dispatch = useDispatch();
  const [disable, setDisable] = useState(false);
  const [value, setValue] = useState('celular');

  useEffect(() => {
    setData({
      ...data,
      infoUser: state.info
    });
  }, []);

  const cambiarValue = e => {
    setValue(e.target.value)
    setData({
      ...data,
      emailTel: e.target.value
    })
  }

  const guardar = async e => {
    e.preventDefault();
    setDisable(true);

    if (value == "celular") {
      setTimeout(() => {
        setDisable(false);
      }, 15000);
      const res = await dispatch(sendCode(data.infoUser));
      setData({
        ...data,
        infoUser: {
          ...data.infoUser,
          codigo: res.data.codigo
        },
        to: res.data.to
      });
      setPasos(2);
      return;
    } else {
      const info = {
        email: data.infoUser.email,
        nombre: data.infoUser.username,
      }
      const res = await dispatch(sendCodeEmail(info));
      setTimeout(() => {
        setDisable(false);
      }, 8000);
      const copyInfo = data.infoUser;
      copyInfo.emailTel = 'email';
      setData({
        ...data,
        infoUser: copyInfo
      });
      setPasos(2);
    }
  }

  return (
    <Grid className="form-steps" size={{ lg: 6 }}>
      <form noValidate onSubmit={guardar}>
        <IconButton
          className="btn-icon"
          aria-label="back"
          onClick={() => navigate(-1)}
        >
          <ChevronLeftIcon />
        </IconButton>
        <Typography variant="h3" component="h3">Verifica tu cuenta</Typography>
        <Typography component="p">Elige cómo deseas verificar tu cuenta.</Typography>
        <FormControl>
          <RadioGroup
            aria-labelledby="demo-radio-buttons-group-label"
            defaultValue="celular"
            name="radio-buttons-group"
            value={value}
            onChange={(event) => cambiarValue(event)}
          >
            <FormControlLabel
              value="email"
              control={<Radio sx={{ color: "#D8DADC" }} />}
              label="Correo electrónico"
            />
            <FormControlLabel
              value="celular"
              control={<Radio sx={{ color: "#D8DADC" }} />}
              label="Número celular"
            />
          </RadioGroup>
        </FormControl>
        <Button
          type="submit"
          fullWidth
          variant="contained"
          color="primary"
          disabled={disable}
        >
          Enviar código
        </Button>
        <Alert />
      </form>
    </Grid>
  );
}

FormSignUpStep2.propTypes = {
  setData: PropTypes.func.isRequired,
  navigate: PropTypes.func.isRequired,
  setPasos: PropTypes.func.isRequired,
  data: PropTypes.object.isRequired,
  state: PropTypes.object.isRequired
}

export default FormSignUpStep2;